import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import { useSelector } from 'react-redux';

export default function Parameters() {
  const [parameters, setParameters] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const columns = [
    {
      title: 'Parâmetro',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'Unidade',
      field: 'unity',
      editable: 'never',
      hideFilterIcon: true,
      // render: rowData => {
      //     if(rowData.hasOption)
      //     return "";
      // },
      render: (rowData) => rowData.unity.sigla,
    },
    {
      title: 'Tipo',
      field: 'type',
      editable: 'never',
      hideFilterIcon: true,
    },
    {
      title: 'Descrição',
      field: 'description',
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/parameters');
        await response.data.map((parameter) => {
          if (parameter.description && parameter.description.length > 15) {
            parameter.description = `${parameter.description.substr(0, 15)}...`;
          }
          return null;
        });
        if (response.data) {
          const data = await response.data;
          const organizedData = await data.map((_parameter) => ({
            name: _parameter.name,
            unity: _parameter.unity.sigla,
            type: _parameter.type,
            description: !_parameter?.description ? 'Nenhuma' : _parameter.description,
          }));

          setParameters(data);
          setExportData(organizedData);
        }
        setOpenProgress(true);
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
      } catch (err) {}
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    parameters.map((parameter) => (parameter.id === newData.id
      ? tempData.push(newData)
      : tempData.push(parameter)));
    setParameters(tempData);
  }
  return (
    <Table
      title="Parâmetros"
      route="/parameters/"
      routeAdd="/parameter/"
      columns={columns}
      data={parameters}
      setData={setData}
      dataLoaded={openProgress}
      exportData={exportData}
    />
  );
}
